import { action, makeObservable, observable } from 'mobx';

import { CardTypes } from '../enums';
import { marketsStore } from './marketsStore';
import { compareCardValues } from '../helpers/compareCardValues';

class GameStore {
  time = null;

  isBetsClosed = false;

  numPadData = { isOpen: false, currentInputValue: null };

  gameAnimationDuration = 1500;

  oddRenderCount = 0;

  mobileGameScene = null;

  timerDuration = 10;

  partnerWageringOdd = null;

  animationToggle = null;

  isPongReceived = false;

  finishedOdd = null;

  pastRoundsHighLowData = {};

  gameState = {
    status: '',
    second: null,
    isInitialLoaded: false,
  };

  constructor() {
    makeObservable(this, {
      time: observable,
      gameState: observable,
      finishedOdd: observable,
      isBetsClosed: observable,
      timerDuration: observable,
      isPongReceived: observable,
      oddRenderCount: observable,
      mobileGameScene: observable,
      numPadData: observable.deep,
      partnerWageringOdd: observable,
      animationToggle: observable.deep,
      gameAnimationDuration: observable,
      pastRoundsHighLowData: observable.deep,
      setTime: action.bound,
      setGameState: action.bound,
      setNumPadData: action.bound,
      setFinishedOdd: action.bound,
      setIsBetsClosed: action.bound,
      setTimerDuration: action.bound,
      setIsPongReceived: action.bound,
      setOddRenderCount: action.bound,
      setAnimationToggle: action.bound,
      setMobileGameScene: action.bound,
      compareCardResults: action.bound,
      setPartnerWageringOdd: action.bound,
      updateCompareCardResults: action.bound,
      setPastRoundsHighLowData: action.bound,
      setGameAnimationDuration: action.bound,
    });
  }

  setTime(time) {
    this.time = time;
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  setPartnerWageringOdd(partnerWageringOdd) {
    this.partnerWageringOdd = partnerWageringOdd;
  }

  setMobileGameScene(mobileGameScene) {
    this.mobileGameScene = mobileGameScene;
  }

  setAnimationToggle(animationToggle) {
    this.animationToggle = animationToggle;
  }

  setPastRoundsHighLowData(data) {
    if (data) {
      this.pastRoundsHighLowData = { ...this.pastRoundsHighLowData, ...data };
    }
  }

  setOddRenderCount(oddRenderCount) {
    this.oddRenderCount = oddRenderCount;
  }

  setNumPadData(data) {
    this.numPadData = data;
  }

  compareCardResults(data) {
    let firstCardData = null;
    let secondCardData = null;
    for (let i = 0; i < data.length; i++) {
      firstCardData = data[i];
      if (firstCardData?.card === CardTypes[0]) continue;
      if (firstCardData) {
        for (let j = i + 1; j < data.length; j++) {
          secondCardData = data[j];
          if (secondCardData?.card === CardTypes[0]) continue;
          this.setPastRoundsHighLowData({
            [firstCardData.id]: compareCardValues(firstCardData, secondCardData),
          });
          if (secondCardData) break;
        }
      }
    }
  }

  updateCompareCardResults() {
    const { latestMarkets } = marketsStore;

    const lastResultData = latestMarkets[1];
    if (lastResultData.card !== CardTypes[0]) {
      const penultimateResultData = latestMarkets.find(
        (el, index) => el.card !== CardTypes[0] && el.id !== lastResultData.id && index !== 0
      );
      this.setPastRoundsHighLowData({
        [lastResultData.id]: compareCardValues(lastResultData, penultimateResultData),
      });
    }
  }

  setGameAnimationDuration(gameAnimationDuration) {
    this.gameAnimationDuration = gameAnimationDuration;
  }

  setFinishedOdd(finishedOdd) {
    this.finishedOdd = finishedOdd;
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setGameState(status) {
    this.gameState = status;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }
}

export const gameStore = new GameStore();
